import { OptionDetailContainer, OptionDetailItem } from './OptionDetailContainer';
import PrevNext from './PrevNext';
import OptionSelect from './OptionSelect';

export default class OptionDetail {
  constructor() {
    this.isSingleDepth = TMON.oApp.htStorage.optionInfo && TMON.oApp.htStorage.optionInfo.totalDepth === 1;
    if (!this.imgUrl) this.setImageList();
    this.orderNo = parseInt(TMON.util.getHashJSON().order_no, 10);
    
    // 1뎁스 딜이면 optionList 호출 후에 render() 실행
    if (TMON.util.getHashJSON().scene === 'scene-optiondetail') {
      this.init();
    }
  }

  init() {
    // 1뎁스 딜이면 optionList 호출 후에 init 실행
    if (this.isSingleDepth && !TMON.oApp.htStorage.optionList) return;

    // orderNo가 imgUrl 목록 범위에서 벗어난 경우 0으로 변경
    this.optionNodes = this.getOptionNodes();
    this.orderNo = parseInt(TMON.util.getHashJSON().order_no, 10);
    if (!this.imgUrl[this.orderNo]) {
      this.orderNo = 0;
      TMON.oApp.oUtil.replaceHash('order_no', this.orderNo);
    }

    this.render();
    this.initSwiper();
    this.clearEvent();
    this.setEvent();
    this.onChangeSlide();
  }

  update(sStorageKey) {
    const { scene } = TMON.util.getHashJSON();
    switch (sStorageKey) {
      case 'scene':
        if (scene === 'scene-optiondetail') {
          this.init();
        } else {
          $('#view-default-scene-optiondetail').html('<div id="optionDetail" class="swiper-container"></div>');
          this.clearEvent();
          this.destroySwiper();
        }
        break;
      case 'optionList':
        if (scene === 'scene-optiondetail' && this.isSingleDepth) {
          this.init();
        }
        break;
      case 'splitContent':
        this.setImageList();
        break;
      default:
        break;
    }
  }

  setImageList() {
    const { splitContent, htStaticData } = TMON.oApp.htStorage;
    const { htDealContentInfo } = htStaticData;

    function getImageList(key1, key2) {
      let imgList = [];
      if (
        splitContent &&
        splitContent.data &&
        splitContent.data[key1] &&
        splitContent.data[key1][key2]
      ) {
        imgList = splitContent.data[key1][key2];
      }
      return imgList.map((el, idx) => {
        return { ...el, nOrderNo: idx };
      });
    }

    if (htDealContentInfo.contentType === 'SUMMARY') {
      this.imgUrl = getImageList('dealSummaryInfo', 'contentList');
      this.imgUrl = this.imgUrl.filter(item => item.summaryContent);
    } else if (htDealContentInfo.contentType === 'OPTION_VIEW_DETAIL') {
      this.imgUrl = getImageList('dealOptionViewDetail', 'imageList');
    }
  }

  setEvent() {
    if (this.oSwipeBySwiperJS) {
      this.oSwipeBySwiperJS.on('slideNextTransitionEnd', () => {
        this.onChangeSlideNext();
      });

      this.oSwipeBySwiperJS.on('slidePrevTransitionEnd', () => {
        this.onChangeSlidePrev();
      });
    }
    $('#optionDetail').on('click', '[data-role=slideNext]', () => {
      this.onClickNext();
    });
    $('#optionDetail').on('click', '[data-role=slidePrev]', () => {
      this.onClickPrev();
    });
    $('#view-default-scene-optiondetail').on(
      'click',
      '[data-role=list-trigger]',
      e => {
        this.onClickListTrigger(e);
      }
    );
    $('#view-default-scene-optiondetail').on(
      'click',
      '[data-role=list-selector]',
      e => {
        this.onClickListSelector(e);
      }
    );
    $('.btn_select_option').on('click', () => {
      this.onClickSelectOpt();
    });
  }

  clearEvent() {
    if (this.oSwipeBySwiperJS) {
      this.oSwipeBySwiperJS.off('slideChange');
    }
    $('#optionDetail').off('click', '[data-role=slideNext]');
    $('#optionDetail').off('click', '[data-role=slidePrev]');
    $('#view-default-scene-optiondetail').off(
      'click',
      '[data-role=list-trigger]'
    );
    $('#view-default-scene-optiondetail').off(
      'click',
      '[data-role=list-selector]'
    );
    $('.btn_select_option').off('click');
  }

  onClickListTrigger(e) {
    $(e.currentTarget)
      .closest('[data-role=list-controller]')
      .toggleClass('open');
  }

  onClickListSelector(e) {
    const nSelectedListOrder = $(e.currentTarget)
      .closest('li')
      .attr('data-listorder');
    this.orderNo = parseInt(nSelectedListOrder, 10);
    TMON.oApp.oUtil.replaceHash('order_no', this.orderNo);
    this.init();
    $(e.currentTarget)
      .closest('[data-role=list-controller]')
      .removeClass('open');
  }

  onClickSelectOpt() {
    const { orderDealMax, optionNo } = TMON.oApp.htStorage.optionList.data[
      this.orderNo
    ];
    const { soldOut } = orderDealMax;
    if (!soldOut) {
      TMON.oApp.setStorage('purchaseOption', {
        aKeyList: [optionNo],
        nCurrentDepth: 0,
      });
    } else {
      alert('선택하신 옵션의 판매가 종료되었습니다. 다시 확인해 주세요.');
    }
  }

  onChangeSlideNext() {
    this.orderNo = this.orderNo + 1;
    if (this.orderNo === this.imgUrl.length) {
      this.orderNo = 0;
    }
    TMON.oApp.oUtil.replaceHash('order_no', this.orderNo);

    let nextOrderNo = this.orderNo + 1;
    if (nextOrderNo === this.imgUrl.length) {
      nextOrderNo = 0;
    } 
  
    const slideHtml = OptionDetailItem(this.imgUrl[nextOrderNo], nextOrderNo, this.optionNodes);
    this.oSwipeBySwiperJS.appendSlide(slideHtml);
    this.oSwipeBySwiperJS.removeSlide(0);
    this.oSwipeBySwiperJS.slideTo(1);
    this.onChangeSlide();
  }

  onChangeSlidePrev() {
    this.orderNo = this.orderNo - 1;
    if (this.orderNo === -1) {
      this.orderNo = this.imgUrl.length - 1;
    }
    TMON.oApp.oUtil.replaceHash('order_no', this.orderNo);

    let prevOrderNo = this.orderNo - 1;
    if (prevOrderNo === -1) {
      prevOrderNo = this.imgUrl.length - 1;
    }

    const slideHtml = OptionDetailItem(this.imgUrl[prevOrderNo], prevOrderNo, this.optionNodes);
    this.oSwipeBySwiperJS.prependSlide(slideHtml);
    this.oSwipeBySwiperJS.removeSlide(3);
    this.oSwipeBySwiperJS.slideTo(1);
    this.onChangeSlide();
  }

  initSwiper() {
    this.destroySwiper();
    this.oSwipeBySwiperJS = new window.Swiper('#optionDetail', {
      paginationType: 'custom',
      autoplay: 0,
      loop: false,
      initialSlide: 1
    });
  }

  destroySwiper() {
    if (this.oSwipeBySwiperJS) {
      this.oSwipeBySwiperJS.destroy();
      delete this.oSwipeBySwiperJS;
    }
  }

  getSelectedOptionTitle() {
    if (!this.isSingleDepth) {
      const { optionInfo } = TMON.oApp.htStorage;
      if (!optionInfo) return '';
      const selectedOption = optionInfo.options[0][this.orderNo];
      return selectedOption ? selectedOption.value : '';
    }

    const { optionList } = TMON.oApp.htStorage;

    if (!optionList || !optionList.data || !optionList.data[this.orderNo]) return '';

    let title = '';
    if (optionList.data[this.orderNo].isBundleOnly) {
      title = '<strong class="addoption">[추가구매상품] </strong>'
    }
    title += optionList.data[this.orderNo].optionTitle;

    return title;
  }

  onChangeSlide() {
    if (TMON.oApp.sPlatform === 'PW') {
      $('#optionDetail').scrollTop(0, 0);
    } else {
      window.scroll(0, 0);
    }

    const { optionInfo } = TMON.oApp.htStorage;
    if (optionInfo) {
      const selectedOption = optionInfo.options[0][this.orderNo];
      if (selectedOption) {
        if (optionInfo.totalDepth > 1) {
          const aKeyList = [];
          aKeyList[0] = selectedOption.key;
  
          TMON.oApp.setStorage('purchaseOption', {
            aKeyList,
            nCurrentDepth: 0,
          });
        }
      }
    }

    $("#view-default-scene-optiondetail [data-role=list-trigger]").html(this.getSelectedOptionTitle());
    this.setHeight();
  }

  setHeight() {
    if (TMON.oApp.sPlatform === 'PW') {
      const height = '100%';
      $('#optionDetail').css('height', height);
      $('#optionDetail').find('li.swipe-item').css({ height, overflow: 'hidden' });
    } else {
      $('#optionDetail')
        .find('li.swipe-item')
        .css('height', $(window).height());
    }
    $('#optionDetail')
      .find(`li.swipe-item[data-order=${this.orderNo}]`)
      .css({ height: 'auto', overflow: 'visible' });
  }

  onClickNext() {
    if (!this.oSwipeBySwiperJS) return;
    this.oSwipeBySwiperJS.slideNext(100);
  }

  onClickPrev() {
    if (!this.oSwipeBySwiperJS) return;
    this.oSwipeBySwiperJS.slidePrev(100);
  }

  render() {
    $('#optionDetail').html(`
      ${OptionDetailContainer(this.imgUrl, this.optionNodes, this.orderNo)}
      ${this.imgUrl.length > 0 ? PrevNext() : ''}
    `);
    $('#view-default-scene-optiondetail').prepend(
      OptionSelect(this.isSingleDepth, this.optionNodes)
    );
    $('body').find('div.files').remove();
    $('body').find('.tmde-component-option').remove();
  }

  getOptionNodes() {
    const { optionInfo, optionList } = TMON.oApp.htStorage;
    if (!optionInfo || !optionInfo.options) return null;
    if (this.isSingleDepth) {
      return optionList && optionList.data;
    }
    return optionInfo.options[0];
  }
}
